<template>
  <span>
    <a-tag v-if="state" :color="color" style="width: 58px;">{{ $t(`service_busyness_type.${state}`) }}</a-tag>
    <a-tag v-else :color="color" style="width: 58px;">{{ score }}分</a-tag>
  </span>
</template>

<script>
export default {
  name: 'ScoreTag',
  props: {
    score: {
      type: Number
    },
    state: {
      type: String
    }
  },
  computed: {
    color () {
      let c = '#f5222d'
      if (this.state) {
        if (this.state === 'idle') c = '#43B94D'
        else if (this.state === 'busy') c = '#fa8c16'
        else if (this.state === 'normal') c = '#51a8f2'
      } else {
        if (this.score >= 80) c = '#43B94D'
        else if (this.score >= 60) c = '#fa8c16'
      }
      return c
    }
  }
}
</script>
